export default {
	project_name: 'Academia Pintuco',
	company_agency: 'Company / Store',
	no_company_agency_found: "Company / Store no encontrada",
	add_new_company:	"Add new Company / Store",
}
